// import { merchantlogin } from '@api/index'
/* import common from '../../js/common.js'
import vue from 'vue' */
export default {
  state: {
    access_token: "",
    expire_in: "",
    mch_pw: "",
    mch_id: ""
  },
  actions: {
    login({ commit, state }) {
      // console.log((new Date).valueOf - state.expire_in)
      /*  console.log(commit)
          console.log("common", common)
          console.log("vue", vue.prototype) */
      // merchantlogin({state.access_token,})
      commit('LOGIN')
    }
  },
  mutations: {
    LOGIN(a, b) {
      console.log("a", a)
    },
    SETDATA(state, value) {
      // state.access_token=
      console.log("state", state)
      console.log("value", value)
      state.access_token = value.access_token
      state.expire_in = value.expire_in
      state.mch_id = value.mch_id
      state.mch_pw = value.mch_pw
    }
  }
}
